import React, { useEffect, useRef, useState } from 'react'; //import React Component

export function ShowText(props) {
    const [data, setdata] = useState([])
    const [dataFinal, setdataFinal] = useState([])
    let userName = localStorage.getItem("currentLoginUser")
    let userID = localStorage.getItem("currentLoginUserID");
    useEffect(() => {
        if (userName !== null && userID !== null) {
            setdata(props.chatExist)
        }
    })

    function scrollToBottom() {
        const element = document.querySelector(".showText");
        element.scrollTop = element.scrollHeight;
    }

    useEffect(() => {
        if (data !== null && data !== undefined && props.chatUser !== null && props.chatUser !== undefined) {
            if (data.length > 0 && props.chatUser.length > 0) {
                let array = data.filter((content) => {
                    return content.Dialogue[0][Object.keys(content.Dialogue[0])[0]].userID === props.chatUser
                })
                setdataFinal(array)
            }

        } else if (data !== null && data !== undefined) {
            if (data.length > 0) {
                let array = data.filter((content) => {
                    return content.Dialogue[0][Object.keys(content.Dialogue[0])[0]].userID === userID
                })
                setdataFinal(array)
            }

        }
    }, [data, props.chatUser, props.chatExist])

    const [test, settest] = useState(0)
    useEffect(() => {
        scrollToBottom()
    }, [test])

    const [eachText, setEachText] = useState(null);

    useEffect(() => {
        if (dataFinal.length > 0) {
            let finalArray = dataFinal[0].Dialogue;
            settest(finalArray.length)
            finalArray.sort(
                (a, b) => a[Object.keys(a)]["realtime"] - b[Object.keys(b)]["realtime"]
            );
            const mappedArray = finalArray.map((content) => {
                let name = content[Object.keys(content)].userName;
                let showtime = content[Object.keys(content)].showtime;
                let text = content[Object.keys(content)].text;
                let ifOwnText = name === userName ? "eachText2" : "eachText1";
                return (
                    <div key={showtime} id="eachText" className={ifOwnText}>
                        <div className="eachText_time">{showtime}</div>
                        <div className="eachText_name">{name}</div>
                        <div className="eachText_text">{text}</div>
                    </div>
                );
            });
            setEachText(mappedArray);
        }
    }, [dataFinal]);

    return (
        <div className='showText'>
            {eachText}
        </div>
    );
}